'use client';

import React from 'react';
import { Avatar, Chip, Link } from '@heroui/react';
import { RevshareAccount } from '../types';
import { Typography } from '../../../../components';

interface IdCellProps {
  account: RevshareAccount;
}

const IdCell: React.FC<IdCellProps> = ({ account }) => {
  // Normalize type to uppercase for display
  const normalizedType = account.type?.toUpperCase() || 'FREE';
  const isFree = normalizedType === 'FREE';

  return (
    <div className="flex items-start gap-4 py-2">
      <Avatar
        src={account.avatar}
        alt={account.name}
        showFallback
        name={account.name?.slice(0, 1)}
        className="w-8 h-8 rounded-2"
      />
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <Typography variant="label2">
            {/* @ts-ignore */}
            {account.of_user_id?.toString()?.slice(-4)}
          </Typography>
          <Link
            href={`https://onlyfans.com/${account.of_user_name}`}
            target="_blank"
            className="text-sm text-partner hover:underline"
          >
            @{account.of_user_name}
          </Link>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {/* Campaign type chips (CPL, RevShare) */}
          {account.company_types?.includes('cpl') && (
            <Chip
              size="sm"
              classNames={{
                base: 'bg-[rgba(120,40,200,0.2)] h-6 px-1',
                content: 'text-accent text-xs font-normal px-1',
              }}
            >
              CPL
            </Chip>
          )}
          {account.company_types?.includes('refshare') && (
            <Chip
              size="sm"
              classNames={{
                base: 'bg-[rgba(120,40,200,0.2)] h-6 px-1',
                content: 'text-accent text-xs font-normal px-1',
              }}
            >
              RevShare
            </Chip>
          )}
          {/* Account type chip (FREE/Paid) */}
          <Chip
            size="sm"
            classNames={{
              base: 'bg-[rgba(0,111,238,0.2)] h-6 px-1',
              content: 'text-partner text-xs font-normal px-1',
            }}
          >
            {isFree ? 'FREE' : account.price ? `$${account.price}` : 'Free-Trial'}
          </Chip>
          {/* Popularity percent chip */}
          {account.overall_popularity_percent !== undefined &&
            account.overall_popularity_percent > 0 && (
              <Chip
                size="sm"
                classNames={{
                  base: 'bg-[rgba(245,165,36,0.2)] h-6 px-1',
                  content: 'text-warning text-xs font-normal px-1',
                }}
              >
                {account.overall_popularity_percent}%
              </Chip>
            )}
        </div>
      </div>
    </div>
  );
};

export default IdCell;
